import React from "react";
import { Color } from "../../../../Utils/styles";
import Loading from "../../../Common/Loading";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { RtlMui } from "../../../../App/component/rtlMui";
const Search = ({ isApp, data, setSearch, search, loading }) => {
  if (loading) {
    return (
      <div className="search-box-faq">
        <div className="row justify-content-center my-2">
          <Loading count={1} col={7} height={43} />
        </div>
        <div className="row justify-content-center">
          <div className="col-md-7 col-sm-9">
            <div className="row justify-content-center">
              <Loading count={4} height={110} />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={!isApp && "search-box-faq "} style={{ backgroundColor: !isApp && Color.primary }}>
      {!isApp && <div className="row ">
        <div className="col-12 text-center">
          <h3 className="mb-2 search-box-faq-header">
            {/* چه سوالی برات پیش اومده؟ */}
          </h3>
        </div>
      </div>}
      {!isApp &&
        <div className="row justify-content-center my-2">
          <div className="col-md-7 col-sm-9">
            <div className="d-flex new-box-shadow search-box-card" style={{}}>
              <input
                placeholder="چه سوالی برات پیش اومده؟"
                className="p-2"
                onChange={({ target: { value } }) => {
                  setSearch({ ...search, value });
                }}
              />
              <button className=" btn-red py-2 px-4">
                <img src={window.origin + "/img/search.png"} style={{}} />
              </button>
            </div>
          </div>
        </div>
      }
      <div className="d-flex flex-wrap mt-3 justify-content-center align-items-center faq-categories"
      // style={{ position: "absolute" }}
      >
        {isApp &&
          <div className="mt-3 mb-4 px-3 w-100">
            <RtlMui>
              <FormControl variant="filled" style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-filled-label">انتخاب دسته بندی</InputLabel>
                <Select onChange={e => {
                  console.log(e);
                  setSearch({
                    ...search,
                    category_id: search.category_id == e.target.value ? null : e.target.value,
                  });
                }}
                  fullWidth className="slFilter">
                  {
                    data
                      ? data.map((ele, key) => (
                        <MenuItem key={key} value={ele.id}>{ele.title}</MenuItem>
                      ))
                      : <MenuItem value={"..."}>...</MenuItem>

                  }
                </Select>
              </FormControl>
            </RtlMui>
          </div>
        }
        {!isApp &&
          data.map((ele, key) => {
            return (
              <button
                key={key}
                className="new-box-shadow btn-category"
                onClick={() => {
                  setSearch({
                    ...search,
                    category_id: search.category_id == ele.id ? null : ele.id,
                  });
                }}
                style={{
                  border:
                    ele.id === search.category_id
                      ? `2px solid #E42A3F`
                      : "1px solid rgba(0, 0, 0, 0.12)",
                }}
              >
                <div className="d-flex justify-content-center">
                  <img src={ele.photo} alt="" style={{}} />
                </div>
                <div>
                  <span
                    className="category-text"
                    style={{
                      color:
                        ele.id === search.category_id
                          ? Color.primary
                          : Color.black,
                    }}
                  >
                    {ele.title}
                  </span>
                </div>
              </button>
            );
          })}
      </div>
    </div>
  );
};

export default Search;
